import React, { useState, useEffect } from 'react';
import { Alert, Form, Button, Dropdown, DropdownButton } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * スキルシート選択 ページ
 * 
 * @param {firebaseUser} Firebase User
 * @param allUser 全ユーザー 
 * @returns スキルシート選択 ページ
 */
function SkillPage({ firebaseUser, allUser }) {
    useEffect(() => {
        document.title = "スキルシート";
    }, []);

    const navigate = useNavigate();
    const [myEmployee] = useState(() => {
        return allUser.find(u => u.id === firebaseUser.uid);
    });

    const [customName, setCustomName] = useState('');

    const [user, selectUser] = useState(() => {
        return (
            allUser.find(u => u.id === firebaseUser.uid && !u.leave)
            || allUser.find(u => u.role < 3 && !u.leave)
        );
    });

    const [outputDate, setOutputDate] = useState(() => {
        const today = new Date();
        const formattedDate = today.toISOString().slice(0, 10);
        return formattedDate;
    });

    function getUserFullName(user) {
        if (user.role == 3) {
            return "選択してください";
        }
        console.log(user);
        return user.lastName + " " + user.firstName;
    }

    const handleSubmit = () => {
        // 管理者(role=3)は常に不可
        if (user.role === 3) {
            return;
        }

        // 退職者は admin(role=1) 以外は不可
        if (user.leave && myEmployee.role !== 1) {
            return;
        }

        navigate('/skill/detail', {
            state: {
                employee: user,
                myEmployee: myEmployee,
                date: outputDate,
                customName: customName
            }
        });
    };

    return (
        <>
            <h1>スキルシート</h1>

            <Alert key='info' variant='info' className='mt-5'>
                スキルシートを生成します。<br />
                ユーザーを選択して最後に「出力」を押下してください。
            </Alert>

            <Form onSubmit={handleSubmit} className='mt-5 mb-5'>
                <Form.Group controlId="customName" className='mt-3'>
                    <DropdownButton
                        variant="outline-secondary"
                        title={getUserFullName(user)}
                    >
                        {allUser
                            .filter(employee => {
                                // 管理者(role=3)は選択肢に出さない
                                if (employee.role === 3) return false;

                                // admin(role=1)は退職者も見える
                                if (myEmployee.role === 1) return true;

                                // それ以外(role=2など)は退職者を見せない
                                return !employee.leave;
                            })
                            .map(user => (
                                <Dropdown.Item
                                    key={user.id}
                                    onClick={() => selectUser(user)}
                                >
                                    {getUserFullName(user)}{user.leave ? "（退職）" : ""}
                                </Dropdown.Item>
                            ))}
                    </DropdownButton>
                </Form.Group>


                <Form.Group controlId="customName" className='mt-3'>
                    <Form.Control
                        className='mt-3'
                        value={customName}
                        onChange={e => setCustomName(e.target.value)}
                        placeholder="表示名 - 氏名の変更表示する場合(匿名にする場合はスペース)"
                    />
                </Form.Group>

                <Form.Group controlId="formMessage" className='mt-3'>
                    <Form.Control
                        type='date'
                        placeholder="出力日"
                        onChange={e => setOutputDate(e.target.value)}
                    />
                </Form.Group>

                <div className="d-grid gap-2 mt-3">
                    <Button variant="primary" type="submit" size="lg" onClick={() => handleSubmit()}>
                        出力
                    </Button>
                </div>
            </Form>

            {myEmployee.role === 1 && (
                <Button variant='secondary' onClick={() => {
                    navigate('/skill/import');
                }}>
                    スキルインポート
                </Button>
            )}
        </>
    );
}

export default SkillPage;
